import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "expedients-list py-56" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = { class: "d-flex mb-48" }
const _hoisted_7 = { class: "d-flex table-responsive" }
const _hoisted_8 = { class: "fit" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_11 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_12 = { class: "h5 title text-primary mb-48" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add-ring me-8",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_14 = { class: "fit text-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_16 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('pacientes')), 1)
      ]),
      (_ctx.can('professional.expedient.store'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {name: 'professional.expedient.store'},
            class: "btn btn-secondary btn-icon btn-sm",
            "aria-label": _ctx.$t('Nuevo paciente')
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Nuevo paciente')), 1)
            ]),
            _: 1
          }, 8, ["to", "aria-label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_input, {
        id: "search",
        class: "me-8",
        placeholder: _ctx.$t('Buscar paciente'),
        value: _ctx.filters.search,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => {_ctx.filters.search = $event; _ctx.search()})
      }, null, 8, ["placeholder", "value"]),
      _createVNode(_component_v_button, {
        variant: "secondary",
        class: "btn-icon text-nowrap",
        "aria-label": _ctx.$t('Limpiar filtros'),
        onClick: _ctx.emptyFilters
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Limpiar filtros')), 1)
        ]),
        _: 1
      }, 8, ["aria-label", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_v_table, { class: "table-bordered" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table_header, null, {
            default: _withCtx(() => [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Nombre')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Apellido')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('NIF / DNI')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Género')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('Fecha nacimiento')), 1),
                _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('Acciones')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_table_body, null, {
            default: _withCtx(() => [
              (!_ctx.expedients.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('No hay pacientes')), 1),
                        (_ctx.can('professional.expedient.store'))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: {name: 'professional.expedient.store'},
                              class: "btn btn-secondary btn-icon btn-sm",
                              "aria-label": _ctx.$t('Nuevo paciente')
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('Nuevo paciente')), 1)
                              ]),
                              _: 1
                            }, 8, ["to", "aria-label"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expedients, (expedient) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: expedient.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(expedient.patient.user.name), 1),
                  _createElementVNode("td", null, _toDisplayString(expedient.patient.user.surname), 1),
                  _createElementVNode("td", null, _toDisplayString(expedient.patient.nif), 1),
                  _createElementVNode("td", null, _toDisplayString(expedient.patient.genre === 'male' ? 'Masculino' : 'Femenino'), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$str.formatDate(expedient.patient.bornDate)), 1),
                  _createElementVNode("td", _hoisted_14, [
                    (_ctx.can('professional.expedient.show'))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {name: 'professional.expedient.show',
                params: { expedient:  expedient.id, tabName: 'general'},
                query: { tratamiento: this.currentTreatment?.id }},
                          class: "btn btn-icon btn-sm justify-content-center d-flex flex-column p-0",
                          "aria-label": _ctx.$t('Ver')
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15,
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('Ver')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "aria-label"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.expedients.length > 0)
      ? (_openBlock(), _createBlock(_component_v_pagination, {
          key: 0,
          meta: _ctx.expedientsPagination?.meta,
          pagination: _ctx.expedientsPagination?.pagination,
          onPageChanged: _ctx.handlePageChangedEvent
        }, null, 8, ["meta", "pagination", "onPageChanged"]))
      : _createCommentVNode("", true)
  ]))
}